import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import Tag from '../blog-card/tag';
const BlogTags = (props) => {
    const { category, platform, profession, textClass } = props;
    let tagCount = 0;
    if (category || platform || profession) {
        tagCount += 1;
    }
    return (_jsxs(Fragment, { children: [category?.slug && (_jsx(Tag, { tagCount: tagCount, endpoint: "/blog/category", slug: category.slug, name: category.name, textClass: textClass })), platform?.slug && (_jsx(Tag, { tagCount: tagCount, endpoint: "/blog/platforms", slug: platform.slug, name: platform.name, textClass: textClass })), profession?.slug && (_jsx(Tag, { tagCount: tagCount, endpoint: "/blog/profession", slug: profession.slug, name: profession.name, textClass: textClass }))] }));
};
export default BlogTags;
